import React from 'react';

import Header from '../partials/Header';
import PolicyFeatures from '../partials/PolicyFeatures';
import Cta from '../partials/Cta';
import Footer from '../partials/Footer';

function PolicyMaking() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="flex-grow">

        {/*  Page sections */}
        <PolicyFeatures />
        <Cta />

      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default PolicyMaking;